import { BIZ_DATA } from '../constants/actions';

let businessCode = '';
let businessDetails = {};
const businessAppsData = {};
let subformCounterObj = {};
let dynamicFormCount = 0;
let dynamicTableFormCount = 0;
let dataActionsFieldsData = {};
let activeBreadCrumb = null;
let microSoftToken = null;
let isKioskMode = false;
let isKioskTxnCreateHedaer = '';
let isLocationPermission = false;

export const setBusinessDetails = (resp) => {
  businessDetails = resp;
  return {
    type: BIZ_DATA,
    payload: resp,
  };
};

export const getBusinessDetails = () => {
  return businessDetails || {};
};

export const setBizCode = (code) => {
  if (code) {
    businessCode = code;
  }
};

export const getBizCode = () => {
  return businessCode;
};

export const getIsNewUI = () => {
  return businessDetails?.generalInfo?.allowNewUI || false;
};

export const getTemplateCode = () => {
  return businessDetails?.template?.code;
};

export const getTemplateLandingPage = () => {
  return businessDetails?.template?.landingPage;
};

export const setBusinessAppsData = (appsData) => {
  businessAppsData[businessDetails?.id] = {};
  businessAppsData[businessDetails?.id] = appsData
};

export const getBusinessAppsData = () => {
  return businessAppsData[businessDetails?.id];
};

export const setSubformOpenCounter = (refId, counter, setEmpty) => {
  if(setEmpty){
    subformCounterObj = {};
  }else if(refId){
    subformCounterObj[refId] = counter;
  }
  return subformCounterObj;
}

export const getSubformOpenCounter = () => {
  return subformCounterObj;
}

export const setTxnDynamicFormCounter = (counter) => {
  dynamicFormCount = counter || 0;
}

export const getTxnDynamicFormCounter = () => {
  return dynamicFormCount;
}

export const setTxnTableFormCounter = (counter) => {
  dynamicTableFormCount = counter || 0;
}

export const getTxnTableFormCounter = () => {
  return dynamicTableFormCount;
}

export const setDataActionsFieldsData = (fieldsData) => {
  dataActionsFieldsData = fieldsData;
};

export const getDataActionsFieldsData = () => {
  return dataActionsFieldsData || {};
};

export const getLogMoniterEnableKey = () => {
  return businessDetails?.generalInfo?.enableLogMonitoring || false;
};

export const getActiveBreadCrumb = () =>{
  return activeBreadCrumb;
}

export const setActiveBreadCrumb = (breadcrumb) =>{
  activeBreadCrumb = breadcrumb;
}

// setting Microsoft token
export const setMicroSoftToken = (token) => {
  microSoftToken = token;
}

// getting Microsoft token
export const getMicroSoftToken = () => {
  return microSoftToken;
}

// getting kisosk mode enabled or not from business details
export const getKioskModeEnabled = () => {
  return businessDetails?.generalInfo?.enableKioskMode || true;
};

// setting kiosk mode enabled or not from dropdown
export const setIsKioskModeEnabled = (isKioskModeEnabled) => {
  isKioskMode = isKioskModeEnabled;
};

// getting kiosk mode enabled or not from dropdown
export const getIsKioskModeEnabled = () => {
  return isKioskMode;
};

// setting kiosk txn header
export const setKioskTxnCreateHedaer = (title) => {
  isKioskTxnCreateHedaer = title;
};

// getting kiosk txn header
export const getKioskTxnCreateHedaer = () => {
  return isKioskTxnCreateHedaer;
};
export const setIsLocationPermission = (isLocPermission) => {
  isLocationPermission = isLocPermission;
}

export const getIsLocationPermission = () => {
  return isLocationPermission;
}
